import React, { useReducer, useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  CustomInput,
  ModalBody,
  ModalFooter,
  Col,
  Row,
  Container,
  Input,
  Button,
  Table,
} from "reactstrap";
import { initialize, defaultState } from "./store/store";
import style from "./Collateral.module.scss";
import { custodyReducer, validateForm } from "./store/reducer";
import Footer from "./Footer";
import { Numeric, Combobox, Field } from "../Order/Field/Field";
import Symbol from "./components/Symbol";
import CollateralWarranty from "./components/CollateralWarranty";
import Account from "../IO/Fields/Account";
import { getIntStatusName, getCWRelatedEntities } from "../../Collateral/types";
import { getEnabledStatus, getRelatedEntities } from "./utils";
import CircularProgress from "../../CircularProgress/CircularProgress";
import { FormattedDate } from "react-intl";
import { FormattedNumber } from "../../FormattedNumber/FormattedNumber";
import { Mode } from "../../../utils";
import { showToast } from "../../../utils/Helper";

const Collateral = ({ open, toggle, services, role, ...props }) => {
  const [state, dispatch] = useReducer(custodyReducer, defaultState(), initialize(props));
  const { fields, collateral, ui } = state;
  const [showCollateralWarranty, setshowCollateralWarranty] = useState(false);
  const { errors, readonly } = fields;
  const { collaterals, products } = collateral;
  const [collateralWarrantyItem, setCollateralWarranty] = useState(null);
  const [toDelete, setToDelete] = useState(false);
  const [toEdit, setToEdit] = useState(false);

  if (state.buttons.confirm.visible == false) {
    dispatch({ type: "CHANGE_MODE", mode: Mode.CONFIRM });
  }

  const onChange = (fields) => {
    dispatch({ type: "CHANGE_FIELDS", fields });
  };

  const addCollateralWarranty = (collateralWarranty) => {
    let sameDate = false
    collateral.collaterals.forEach((c) => {
      if (c.AssetId == collateralWarranty.AssetId){
        if (c.CollateralMaturity == collateralWarranty.CollateralMaturity){
          sameDate = true;
          if (collateralWarranty.ToEdit!=true){
            showToast("Error: " + "Can't add same Asset already added with same expiration date", true);
          }
          else{
            if (collateralWarranty.index == c.index){
              dispatch({ type: "ADD_COLLATERAL_WARRANTY", collateralWarranty });
            }
            else{
              showToast("Error: " + "Can't edit same Asset with already added same expiration date", true);
            }
          }
        }
      }
    })
    if (!sameDate){
      dispatch({ type: "ADD_COLLATERAL_WARRANTY", collateralWarranty });
    }
  };

  const getTotalAvailable = () => {
    let totalAvailable = 0;
    collateral.collaterals.map((c) => {
      totalAvailable += Math.floor(c.CollateralQuantity);
    });
    return totalAvailable;
  };

  const getTotalRequired = () => {
    let totalRequired = 0;
    return totalRequired;
  };

  const confirm = () => {
    dispatch({ type: "CHANGE_BUTTON_PROPS", props: { confirm: { loading: true } } });

    services
      .fetchUpdateCollateral({
        gcpool: {
          ...collateral,
        },
      })
      .then((r) => {
        if (r) {
          if (r.error) {
            dispatch({ type: "CHANGE_BUTTON_PROPS", props: { confirm: { loading: false } } });
            showToast("Error:" + r.error.message, true);
          } else {
            if (r.result.Code === 200) {
              toggle();
              showToast("Updated successfully");
              props.updateCollaterals();
            }
            else { 
              if (toDelete){
                dispatch({ type: "DELETE_COLLATERAL_WARRANTY_FAIL"});
                showToast("Error: " + (r.error ? r.error.message : "Failed to delete"), true);
                setToDelete(false);
              }
              collaterals.forEach((c) => {
                if (c.ToEdit && c.CollateralStatus == "Inactive"){
                  c.CollateralStatus = "Active"
                }
              })
              setToEdit(false);
              showToast("Error: " + r.result.Description, true);
              dispatch({ type: "CHANGE_BUTTON_PROPS", props: { confirm: { loading: false } } });
            }
          }
        } else {
          dispatch({ type: "CHANGE_BUTTON_PROPS", props: { confirm: { loading: false } } });
          showToast("Error: " + "Server error", true);
        }
      });
  };

  const deleteCollateralWarranty = (index) => {
    setToDelete(true);
    dispatch({ type: "DELETE_COLLATERAL_WARRANTY_REQUEST", collateralWarranty: index });
    };

  const toggleEdit = (cw) => {
    cw.ToEdit = true;
    setToEdit(true);
    setCollateralWarranty(cw);
    setshowCollateralWarranty(true);
};

  return (
    <Modal isOpen={open} className={style.modal}>
      <ModalHeader toggle={toggle}>General Collateral Pool</ModalHeader>
      <ModalBody className={style.body}>
        <div className={style.form}>
          {ui.loading && <CircularProgress />}
          {!ui.loading && (
            <Container>
              <Row>
                {/* Left */}
                <Col xs={8} lg={4}>
                  <Account
                    label={"Account"}
                    AccountId={collateral.Accountid}
                    AccountName={collateral.Accountname}
                    AccountNumber={collateral.Accountid}
                    disabled={true}
                    onChange={(f) => onChange(dispatch, f)}
                    filter={[]}
                    hideInstruction={true}
                    hideHolder={true}
                    readonly={{
                      AccountName: true,
                    }}
                    errors={{
                      AccountNumber: errors.accountNumber,
                    }}
                    services={{
                      fetchSearchAccount: services.fetchSearchAccount,
                    }}
                  />
                </Col>
                <Col xs={8} lg={4}>
                  <Field label={"Description"} error={errors.Poolname}>
                    <Input
                      tabIndex="3"
                      type="text"
                      placeholder={"Description"}
                      disabled={true}
                      value={collateral.Poolname}
                      invalid={!!errors.Poolname}
                      onChange={(e) => onChange({ Poolname: e.target.value })}
                    />
                  </Field>
                </Col>
              </Row>
              <Row>
                <Col xs={8} lg={4}>
                  <Field label={"Related entity"}>
                    <Combobox
                      value={collateral.GCPoolRelated}
                      items={getRelatedEntities(collateral).map((key, index) => ({
                        id: key,
                        description: getCWRelatedEntities(key),
                      }))}
                      disabled={true}
                      invalid={!!errors.status}
                      onChange={(v) => onChange({ GCPoolRelated: v })}
                      emptyLabel={"realtedEntity"}
                      style={{ background: "#edf9ff", fontWeight: 500 }}
                    />
                  </Field>
                </Col>
                <Col xs={8} lg={4}>
                  <Field label={"Status"} error={errors.type}>
                    <Combobox
                      value={collateral.status}
                      items={getEnabledStatus(collateral).map((key, index) => ({
                        id: key,
                        description: getIntStatusName(key),
                      }))}
                      disabled={true}
                      invalid={!!errors.status}
                      onChange={(v) => onChange({ status: v })}
                      emptyLabel={"Status"}
                      style={{ background: "#edf9ff", fontWeight: 500 }}
                    />
                  </Field>
                </Col>
                {collateral.GCPoolRelated != "Other" && (
                  <Col xs={8} lg={4}>
                    <Field label={"?"} error={errors.date}>
                      <Input
                        tabIndex="3"
                        type="text"
                        disabled={true}
                        placeholder={"Repo xxx"}
                        value={collateral.GCPoolRelatedEntityId}
                        invalid={!!errors.GCPoolRelatedEntityId}
                        onChange={(e) => onChange({ GCPoolRelatedEntityId: e.target.value })}
                      />
                    </Field>
                  </Col>
                )}
              </Row>
              <Row>
                <Col xs={8} lg={4}>
                  <Field label={"Total Available"}>
                    <Numeric
                      value={getTotalAvailable()}
                      placeholder={"TotalAvailable"}
                      disabled={true}
                      onChange={(v) => onChange({ TotalAvilable: v })}
                      invalid={!!errors.volume}
                      dataTypeDecimalName="currency"
                    />
                  </Field>
                </Col>
                <Col xs={8} lg={4}>
                  <Field label={"Total Required"}>
                    <Numeric
                      value={getTotalRequired()}
                      disabled={true}
                      onChange={(v) => onChange({ TotalRequiered: v })}
                      invalid={!!errors.volume}
                      dataTypeDecimalName="currency"
                    />
                  </Field>
                </Col>
                <Col xs={8} lg={4}>
                  <Field label={"Margin"}>
                    <Numeric
                      value={collateral.Margin}
                      placeholder={"Margin"}
                      disabled={true}
                      onChange={(v) => onChange({ TotalAvailable: v })}
                      invalid={!!errors.volume}
                      dataTypeDecimalName="currency"
                    />
                  </Field>
                </Col>
              </Row>
              <Row>
                <Col xs={8} lg={4}>
                  <Field>
                    <CustomInput
                      id={`cbox-${collateral.id}`}
                      type="checkbox"
                      disabled={false}
                      label="track transfers"
                      checked={collateral.GCPoolTrackTransfers}
                      onChange={(v) => onChange({ GCPoolTrackTransfers: v.target.checked })}
                    />
                  </Field>
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <Input
                    type="textarea"
                    rows={2}
                    placeholder="Notes..."
                    value={collateral.OrderNote}
                    disabled={true}
                    style={{ marginTop: "5px" }}
                    onChange={(e) => onChange(dispatch, { OrderNote: e.target.value })}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Button
                    color="primary"
                    className={`${style.btnAdd} btn-sm mt-1`}
                    onClick={() => {
                      setToEdit(false)
                      setshowCollateralWarranty(true);
                      setCollateralWarranty(null);
                    }}
                  >
                    <i className="fa fa-plus"></i>
                    {"\u00A0"} Add Collateral
                  </Button>
                  <div className={`${style.table}`}>
                    <Table responsive striped>
                      <thead>
                        <tr>
                          <th>Maturity</th>
                          <th>Asset</th>
                          <th>Margin</th>
                          <th>Quantity</th>
                          <th>Status</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {collaterals.length == 0 && <EmptyCollateralsWarranties />}
                        {collaterals.map((collateralWarranty, i) => {
                          collateralWarranty.index = i;
                          if (collateralWarranty.CollateralStatus == "Active") {
                            return (
                              <CollateralWarrantyItem
                                key={`baccount-${i}`}
                                collateralWarranty={collateralWarranty}
                                readonly={false}
                                onDelete={() => deleteCollateralWarranty(i)}
                                onEdit={() => toggleEdit(collateralWarranty)}
                              />
                            );
                          }
                        })}
                      </tbody>
                    </Table>
                  </div>
                  {showCollateralWarranty && (
                    <CollateralWarranty
                      {...props}
                      onChange={onChange}
                      collateralWarrantyItem={collateralWarrantyItem}
                      open={true}
                      errors={errors}
                      readonly={readonly}
                      addCollateralWarranty={addCollateralWarranty}
                      toggle={() => setshowCollateralWarranty(false)}
                      services={{
                        fetchSearchSymbol: services.fetchSearchSymbol,
                        fetchSearchAccount: services.fetchSearchAccount,
                        precheck: services.precheck,
                      }}
                      toEdit={toEdit}
                      setToEdit={setToEdit}
                    />
                  )}
                </Col>
              </Row>
              <Row>
                <Col>
                  <Button
                    color="primary"
                    className={`${style.btnAdd} btn-sm mt-1`}
                    onClick={() => null}
                    disabled={true}
                  >
                    <i className="fa fa-plus"></i>
                    {"\u00A0"} Add position to back
                  </Button>
                  <div className={`${style.table}`}>
                    <Table responsive striped>
                      <thead>
                        <tr>
                          <th>Asset</th>
                          <th>Quantity</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {products.length == 0 && <EmptyCollateralsPositions />}
                        {products.map((collateralPosition, i) => {
                          return (
                            <CollateralPositionItem
                              key={`baccount-${i}`}
                              collateralPosition={collateralPosition}
                              readonly={false}
                              onDelete={() => deleteCollateralWarranty(collateralPosition)}
                              onEdit={() => toggleEdit(collateralPosition)}
                            />
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                </Col>
              </Row>
            </Container>
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <Footer
          toggle={toggle}
          dispatch={dispatch}
          buttons={state.buttons}
          actions={{
            confirm,
          }}
        />
      </ModalFooter>
    </Modal>
  );
};

const CollateralPositionItem = ({ collateralPosition, readonly, onDelete, onEdit }) => (
  <tr>
    <td>{collateralPosition.AssetTicker}</td>
    <td>{collateralPosition.PortfolioQuantity}</td>
    <td>{collateralPosition.PortfolioQuantity * collateralPosition.PortfolioAveragePrice}</td>
    <td>
      <Button color="btn-outline-primary btn-sm" onClick={() => onEdit()} disabled={true}>
        <i className="fa fa-pencil"></i>
      </Button>
      <Button
        color="btn-outline-primary btn-sm"
        disabled={true}
        onClick={() => onDelete(collateralPosition)}
        style={{ color: "#d83737" }}
      >
        <i className="fa fa-trash"></i>
      </Button>
    </td>
  </tr>
);

const CollateralWarrantyItem = ({ collateralWarranty, readonly, onDelete, onEdit }) => (
  <tr>
    <td>
      <FormattedDate value={collateralWarranty.CollateralMaturity} timeZone="UTC" />
    </td>
    <td>{collateralWarranty.AssetTicker}</td>
    <td>
      <FormattedNumber value={collateralWarranty.CollateralMargin} dataTypeDecimalName="currency" />
    </td>
    <td>
      <FormattedNumber value={collateralWarranty.CollateralQuantity} dataTypeDecimalName="quantity" />
    </td>
    <td>{collateralWarranty.CollateralStatus}</td>
    <td>
      <Button color="btn-outline-primary btn-sm" onClick={() => onEdit()}>
        <i className="fa fa-pencil"></i>
      </Button>
      <Button
        color="btn-outline-primary btn-sm"
        disabled={readonly}
        onClick={() => onDelete(collateralWarranty)}
        style={{ color: "#d83737" }}
      >
        <i className="fa fa-trash"></i>
      </Button>
    </td>
  </tr>
);

const EmptyCollateralsWarranties = () => (
  <tr className={style.empty}>
    <td colSpan="3">
      <h5 style={{ textAlign: "center" }}>No Collaterals</h5>
    </td>
  </tr>
);

const EmptyCollateralsPositions = () => (
  <tr className={style.empty}>
    <td colSpan="3">
      <h5 style={{ textAlign: "center" }}>No Positions</h5>
    </td>
  </tr>
);

export function validation(collateral) {
  return {
    AssetId: { empty: true },
    AssetTicker: { empty: true, autosuggestId: "AssetId" },
    CollateralMargin: { empty: true },
    CollateralQuantity: { empty: true },
    CollateralAppraisal: { empty: true },

    CollateralMaturity: { empty: true, date: true },
    CollateralStatus: { empty: true },
  };
}

export default Collateral;
